import { render, staticRenderFns } from "./TXMap.vue?vue&type=template&id=60d65e6b&scoped=true"
import script from "./TXMap.vue?vue&type=script&lang=js"
export * from "./TXMap.vue?vue&type=script&lang=js"
import style0 from "./TXMap.vue?vue&type=style&index=0&id=60d65e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d65e6b",
  null
  
)

export default component.exports